<div class="container">
  <div class="card flat">
    @if (state === 'loading') {
      <app-spinner></app-spinner>
    }
    @if (state === 'display') {
      <div>
        <div class="flex sm-column">
          <div class="promotions" [class]="{'has-data': promotions.length > 0}">
            <h3>My Promotions</h3>
            @if (promotions.length > 0) {
              <div>
                <div>
                  @for (promotion of promotions; track promotion) {
                    <div class="promotion flex">
                      <img [src]="promotion._book.amazonImageUrl" class="cover" />
                      <div class="md-flex">
                        <div class="content">
                          <div class="title">{{ promotion._book.title }}</div>
                          <div class="listing">
                            <div class="site">
                              {{ getSiteNameById(promotion._site) }} - {{ getSiteAdvertNameById(promotion._siteAdvert) }}
                            </div>
                            <div class="date">{{ formatDate(promotion.pubDate) }}</div>
                          </div>
                        </div>
                        <div class="actions">
                          @if (upcoming(promotion.pubDate)) {
                            <div class="status">
                              {{ getStatus(promotion._site) }}
                            </div>
                          } @else {
                            @if (canRerun(promotion)) {
                              <div (click)="rerun(promotion)" class="btn invert sm" >Re-Run</div>
                            }
                          }
                          @if (downloads[promotion._id]) {
                            <button
                              class="btn invert sm"
                              (click)="download(promotion)"
                            >Download</button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <div class="promotion-actions flex sm-column">
                  <div (click)="goFeaturesAction()" class="btn btn-primary">Run a Promotion</div>
                  <div (click)="goPromotionsAction()" class="btn invert">See All Promotions</div>
                </div>
              </div>
            } @else {
              <div class="flex sm-column">
                <div class="promotions-empty"></div>
                <div class="promotions-empty-sm"></div>
                <div class="cta">
                  <div class="header">
                    <p>
                      Unlock the magic of your author portal,
                      where every click is a step closer to turning your words into the world's next favorite story!  📚💫.
                    </p>
                    <button (click)="goFeaturesEmpty()" class="btn huge btn-run-first-book">Run Your First Book Promo</button>
                  </div>
                  <div class="get-started">
                    Feeling overwhelmed? That’s okay! <strong>We're here to help</strong>
                    <div class="flex sm-column">
                      <button (click)="goMyBooksEmpty()" class="btn invert xsm-square">Add Books</button>
                      <button (click)="openSupportEmpty()" class="btn invert xsm-square">Ask a Real Person</button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="stats" [class]="{'has-data': promotions.length > 0}">
            <h3>My Promo Data</h3>
            <div class="stat flex">
              <div class="icon icon-promotions"></div>
              <div class="value">{{statistics.features}}</div>
              <div class="details">
                <div class="label">Promotions Run All Time</div>
                <a (click)="goFeatures()" class="action">Run a Promotion</a>
              </div>
            </div>
            <div class="stat flex">
              <div class="icon icon-stacks"></div>
              <div class="value">{{statistics.stacks}}</div>
              <div class="details">
                <div class="label">Stacks Run All Time</div>
                <a (click)="goPromostacks()" class="action">Run a Stack</a>
              </div>
            </div>
            <div class="stat flex">
              <div class="icon icon-books"></div>
              <div class="value">{{statistics.books}}</div>
              <div class="details">
                <div class="label">Books Uploaded</div>
                <a (click)="goMyBooks()" class="action">Upload Books</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (state === 'error') {
      <div >
        Unable to load module. Error Occurred.
      </div>
    }
  </div>
</div>
